// extracted by mini-css-extract-plugin
module.exports = {"sectionClientsTable":"SalesModalContainer_sectionClientsTable__2Fri2","tableWrap":"SalesModalContainer_tableWrap__2-FXa"};